import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import {Button} from '@material-ui/core';
import numeral from 'numeral';
import {Popover} from 'react-bootstrap';

import SPUtilities from '../util/SPUtilities';
import Utilities from '../util/Utilities';
import RespUtils from '../util/RespUtils';
import IRewardUtils from './IRewardUtils';

import CopyAddress from "../base/CopyAddress";
import SPCalc from '../util/SPCalc';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import config from '../config';
import constants from "../constants";

class IUtils extends React.Component {

  static getProdIndexRating(index) {
    let rating = `Production Index ${index} for the delegate is good. `;
    if (index < 0.75) {
      rating = `Production Index ${index} for the delegate is very low. `;
    } else if (index < 0.95) {
      rating = `Production Index ${index} for the delegate is below average. `;
    }

    return rating;
  }

  static getConsensusPartRating(index) {
    let rating = `Consensus Participation Rate ${index} for the delegate is good. `;
    if (index < 50) {
      rating = `Consensus Participation Rate ${index} for the delegate is very low. This would generally mean that the delegate is not elected regularly. `;
    } else if (index < 63) {
      rating = `Consensus Participation Rate ${index} for the delegate is average. Either the delegate has bit of a bad luck or is not elected regularly or gets probated regularly. `;
    }

    return rating;
  }

  static getProductionRateRating(index) {
    let rating = `Block Production Rate ${index} for the delegate is good. `;
    if (index < 0.95) {
      rating = `Block Production Rate ${index} for the delegate is very low. `;
    } else if (index < 0.99) {
      rating = `Block Production Rate ${index} for the delegate is average. `;
    }

    return rating;
  }

  static prodIndexTip(cell, row, rowIndex, colIndex) {
    let prodIndexRating = IUtils.getProdIndexRating(row.longProdIndex);
    let partRating = IUtils.getConsensusPartRating(row.longElectionRate);
    let prodRate = IUtils.getProductionRateRating(row.longProdRate);
    // console.log("in prodIndexTip for: ", cell, ",", row, ",", rowIndex, ",", colIndex);
    // return this is custom title for ${cell};
    let general = "Production Index depends on Consensus Participation Rate and Block Production Rate. ";
    let message = prodIndexRating + "\n\n" + general + "\n" + partRating + "\n" + prodRate + "\n";
    return message + "________________________________________";
  }

  static prodRateTip(cell, row, rowIndex, colIndex) {
    let prodRate = IUtils.getProductionRateRating(row.longProdRate);
    // console.log("in prodIndexTip for: ", cell, ",", row, ",", rowIndex, ",", colIndex);
    // return this is custom title for ${cell};
    let general = "Production Rate depends on performance of the delegate when it is chosen to participate in consensus. ";
    let message = general + "\n" + prodRate + "\n";
    return message + "________________________________________";
  }

  static blendedShareTip(cell, row, rowIndex, colIndex) {
    // console.log("in blendedShareTip for: ", cell, ",", row);
    let delegate = row;

    let msg1 = `Delegate Block Rewards Per Year: \nTotal - ${delegate.blockRewardsPerYear} IOTX \nNet - ${delegate.netBlockRewardsPerYear} IOTX\n\n`
    let msg2 = `Delegate Foundation Bonus Per Year: \nTotal - ${delegate.foundationBonusPerYear} IOTX \nNet - ${delegate.netFoundationBonusPerYear} IOTX\n\n`
    let msg3 = `Delegate Epoch Bonus Per Year: \nTotal - ${delegate.epochBonusPerYear} IOTX \nNet - ${delegate.netEpochBonusPerYear} IOTX\n\n`
    let msg4 = `Delegate Rewards Per Year: \nTotal - ${delegate.totalRewardsPerYear} IOTX \nNet - ${delegate.netRewardsPerYear} IOTX\n\n`
    let msg5 = `APR: Overall - ${delegate.apr}%, Net - ${delegate.netApr}%\n`
    let msg6 = `Blended Share: - ${delegate.blendedShare}%\n`

    let message = msg1 + msg2 + msg3 + msg4 + msg5 + msg6;
    return message + "___________________________";
  }

  static rewardPercentTip(cell, row, rowIndex, colIndex) {
    // console.log("in rewardPercentTip for: ", cell, ",", row);
    let delegate = row;
    let rewardPerDay = IRewardUtils.rewardPerDay(row.rewardPercentPerDay, row);
    let rewardPerDay91Day = IRewardUtils.get91DayDailyReward10k(row.rewardPercentPerDay, row);

    let msg1 = `APR: Overall - ${delegate.apr}%, Net - ${delegate.netApr}%\n`
    let msg2 = `Blended Share: - ${delegate.blendedShare}%\n`
    let msg3 = `Reward Percent Per Day: - ${delegate.rewardPercentPerDay}%\n`
    let msg4 = `Reward Per Day per 10k IOTX - no auto stake/no bonus votes: - ${rewardPerDay}\n`
    let msg5 = `Reward Per Day for 10K IOTX - 91 day auto stake: - ${rewardPerDay91Day}\n`

    let message = msg1 + msg2 + msg3 + msg4 + msg5;
    return message + "________________________________________";
  }

  static currentProductivityTip(cell, row, rowIndex, colIndex) {
    // console.log("in currentProductivityTip for: ", cell, ",", row);

    let delegate = row;
    let status = delegate.overallStatus;
    let msg1;
    let elected = false;
    if (!status || status == 'NotEligible') {
      msg1 = "The validator is Not Eligible for consensus.\nIt will not earn any reward.\n\n";
    } else if (status == 'Eligible') {
      msg1 = "The validator is Eligible for consensus but not Elected.\nIt will still earn some rewards (ignoring fee aspects).\n\n";
    } else if (status == 'Elected' || status == 'InConsensus') {
      elected = true;
      msg1 = "The validator is Elected in consensus.\nIt will earn good rewards (ignoring fee aspects).\n\n";
    } else if (status == 'Probated') {
      msg1 = "The validator is Probated (likely due to downtime).\nIt will miss out on most of the rewards for 6 epochs after probation.\n\n";
    }


    let msg2;
    if (Utilities.isNaN(cell) || !delegate.productivityBase) {
      // elected = False;
      msg2 = `The validator is not participating in consensus in the current epoch.\n`
      if (elected === true) {
        msg2 += `This is normal. Only 24 out of 36 elected validators participate in every epoch (about 1 hour).\n`
      }
    } else {
      msg2 = `The validator is participating in consensus in the current epoch.\n`
    }

    let message = msg1 + msg2;
    return message + "________________________________________";
  }
}

export default IUtils;



// WEBPACK FOOTER //
// ./src/iotex/ITooltip.js